import { FormattedMessage } from 'react-intl';

import messages from './LoginPromptPopup.messages';
import {
  BodyText,
  CloseButton,
  Container,
  Content,
  Headline,
  IconClose,
  LoginButton,
} from './LoginPromptPopup.styles';

interface LoginPromptPopupProps {
  onClose: () => void;
}

const LoginPromptPopup = ({ onClose }: LoginPromptPopupProps) => {
  return (
    <Container data-testid="login-prompt-popup">
      <CloseButton data-testid="close-button" onClick={onClose}>
        <IconClose />
      </CloseButton>

      <Content>
        <Headline>
          <FormattedMessage {...messages.headline} />
        </Headline>
        <BodyText>
          <FormattedMessage {...messages.body} />
        </BodyText>
        <LoginButton data-testid="login-link">
          <FormattedMessage {...messages.cta} />
        </LoginButton>
      </Content>
    </Container>
  );
};

export default LoginPromptPopup;
